// ─── Geofencing Endpoints ─────────────────────────────────────────────────────

export const API_GET_ALL_GEOFENCING = '/admin/cityFence';
export const API_ADD_GEOFANCING = '/admin/cityFence/add';
export const API_GET_ID_GEOFENCING = '/admin/cityFence/view/';
export const API_EDIT_GEOFENCING = '/admin/cityFence/update';
export const API_DELETE_GEOFENCING = '/admin/cityFence/archive';
